import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { routesConfig } from "../../constants/routesConfig.ts";

const HeaderSearchBar = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [isDropdownVisible, setDropdownVisible] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const navigate = useNavigate();
  const searchRef = useRef<HTMLDivElement>(null);

  const handleNavigate = (path: string) => {
    navigate(path);
    setSearchTerm("");
    setDropdownVisible(false);
    setSelectedIndex(-1);
  };

  const filteredRoutes = routesConfig.filter((route) =>
    route.title.toLowerCase().includes(searchTerm.toLowerCase())
  );

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        searchRef.current &&
        !searchRef.current.contains(event.target as Node)
      ) {
        setDropdownVisible(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (!isDropdownVisible || filteredRoutes.length === 0) return;

    switch (event.key) {
      case "ArrowDown":
        event.preventDefault();
        setSelectedIndex((prevIndex) =>
          prevIndex < filteredRoutes.length - 1 ? prevIndex + 1 : 0
        );
        break;

      case "ArrowUp":
        event.preventDefault();
        setSelectedIndex((prevIndex) =>
          prevIndex > 0 ? prevIndex - 1 : filteredRoutes.length - 1
        );
        break;

      case "Enter":
        if (selectedIndex >= 0 && selectedIndex < filteredRoutes.length) {
          handleNavigate(filteredRoutes[selectedIndex].path);
        }
        break;

      case "Escape":
        setDropdownVisible(false);
        setSelectedIndex(-1);
        break;

      default:
        break;
    }
  };

  return (
    <div className="relative w-full" ref={searchRef}>
      <button
        className="absolute left-0 top-1/2 -translate-y-1/2"
        type="button"
      >
        <i className="fa-regular fa-magnifying-glass fill-body hover:fill-primary dark:fill-bodydark dark:hover:fill-primary fa-lg dark:text-white"></i>
      </button>

      <input
        type="text"
        placeholder="Търсене..."
        className="xl:w-125 w-full bg-transparent py-2 pl-9 pr-4 text-black focus:outline-none dark:bg-gray-800 dark:text-white"
        value={searchTerm}
        onChange={(e) => {
          setSearchTerm(e.target.value);
          setDropdownVisible(true);
          setSelectedIndex(-1);
        }}
        onFocus={() => setDropdownVisible(true)}
        onKeyDown={handleKeyDown}
      />

      {searchTerm && isDropdownVisible && (
        <ul
          className="absolute left-0 right-0 top-full z-10 mt-4 max-h-60 overflow-y-auto
          rounded-b-md border-t border-gray-100 bg-white shadow-lg dark:border-gray-600 dark:bg-gray-700"
        >
          {filteredRoutes.length > 0 ? (
            filteredRoutes.map((route, index) => (
              <li
                key={route.path}
                className={`cursor-pointer px-4 py-2 dark:text-white ${
                  index === selectedIndex
                    ? "text-primary bg-gray-200 dark:bg-gray-600"
                    : "hover:text-primary dark:hover:bg-gray-600"
                }`}
                onClick={() => handleNavigate(route.path)}
              >
                {route.title}
              </li>
            ))
          ) : (
            <li className="px-4 py-2 text-gray-500 dark:text-gray-400">
              Няма намерени резултати
            </li>
          )}
        </ul>
      )}
    </div>
  );
};

export default HeaderSearchBar;
